// Product Collections Mutations

export const setCollectionList = (state, payload) => {
  state.collectionList = payload
}

export const setCollectionInfo = (state, payload) => {
  state.collectionInfo = payload
}
